import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './services/auth/auth-guard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'signin',
    pathMatch: 'full',
  },
  {
    path: 'signin',
    loadChildren: () => import('./common/common.module').then(m => m.CommonAppModule)
  },
  {
    path: 'hubAdmin',
    loadChildren: () => import('./hubadmin/hubadmin.module').then(m => m.HubadminModule)
  },
  {
    path: 'reward',
    loadChildren: () => import('./reward/reward.module').then(m => m.RewardModule)
  },
  {
    path: 'manager',
    loadChildren: () => import('./manager/manager.module').then(m => m.ManagerModule)
  },
  {
    path: 'agent',
    loadChildren: () => import('./agent/agent.module').then(m => m.AgentModule)
  },
  // {
  //   path: 'authorization',
  //   loadChildren: () => import('./authorization/authorization/authorization.module').then(m => m.AuthorizationModule)
  // },

];
@NgModule({
  imports: [RouterModule.forRoot(routes,{
    useHash: true
 })
],
  exports: [RouterModule]
})
export class AppRoutingModule { }
